import * as React from 'react';
import { useEffect } from 'react';
import {
  Navigate,
  Outlet,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useAuthStore } from '../../store';
import { registerAppNavigate, unregisterAppNavigate } from '../app-navigate';

const RedirectNavigator = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    registerAppNavigate(navigate);
    return () => unregisterAppNavigate();
  }, [navigate]);

  const redirect = searchParams.get('redirect');
  // Route authenticated users to the redirect query param maintaining other query params
  if (isAuthenticated && redirect) {
    searchParams.delete('redirect');
    return <Navigate to={{ pathname: redirect, search: searchParams.toString() }} replace />;
  }
  return <Outlet />;
};

export default RedirectNavigator;
